import { initializeApp } from "firebase/app";
import { getRemoteConfig } from "firebase/remote-config";
import { getAnalytics } from "firebase/analytics";

// Même config Firebase que client-dashboard (même projet)
const firebaseConfig = {
    apiKey: "AIzaSyBRilzHIUv9wELnLiL2DLNtSrs8TcxNX4A",
    authDomain: "asso-saas.firebaseapp.com",
    projectId: "asso-saas",
    storageBucket: "asso-saas.firebasestorage.app",
    messagingSenderId: "909841413724",
    appId: "1:909841413724:web:06c8ba0c82a1292f911899",
    measurementId: "G-9L3VGQ0ELK"
};

export const app = initializeApp(firebaseConfig);
export const remoteConfig = getRemoteConfig(app);

export let analytics = null;
// Analytics sera initialisé par initTracking() dans tracking.js si le consentement est donné.
remoteConfig.settings.minimumFetchIntervalMillis = import.meta.env.DEV ? 0 : 3600000;
remoteConfig.defaultConfig = {
    maintenance_mode: JSON.stringify({ active: false, password: '', message: '' }),
    trial_duration_days: "30"
};
